module.exports = __webpack_public_path__ + "images/emoji/u5272.26df789dc1afb05a3ffb.png";